/** @flow */
export function roundNumber(num: number, decimal: number = 0): number {
  const roundPower = 10 ** decimal;
  return Math.round(num * roundPower) / roundPower;
}

export function roundNumberFromObject(obj: Object, decimal: number): Array<number> {
  return Object.values(obj).map(item => roundNumber(Number(item), decimal));
}

export function calculatePercent(count: number, total: number): number {
  return (count / total) * 100;
}

export default { roundNumber, roundNumberFromObject, calculatePercent };



// WEBPACK FOOTER //
// ./src/common/helpers/math.js